<p class="mb-1">
  <strong i18n>
    RiPSIM will generate 'random' OTA keys based on your input for Key Type & Key Size. Please use the options below to make your choice.
  </strong>
</p>
<div class="ml-6 mr-6">
  <div [ngStyle]="{ visibility: errorFound ? 'visible' : 'hidden' }" class="mb-3" style="color: var(--rs-red)">
    <i class="mr-2 pi pi-times-circle"></i>
    <span>{{ errorMessage }}</span>
  </div>
  <table width="100%" cellspacing="0" cellpadding="5" border="1">
    <tr style="background: var(--rs-table-header-bg)">
      <th width="25%" colspan="2" i18n>Secure Channel Protocol</th>
      <th width="10%" i18n>Key Identifier</th>
      <th width="10%" i18n>Key Version Number</th>
      <th width="15%" i18n>Key Type</th>
      <th width="10%" i18n>Key Data</th>
      <th width="30%" i18n>Key Data Value</th>
    </tr>
    <tr>
      <td rowspan="3" style="text-align: center">
        <strong>SCP80</strong>
        <div>(SMS)</div>
      </td>
      <td style="text-align: center">KIC</td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp80.klc.keyIdentifier"
          (input)="handleFormEvents()"
        />
      </td>
      <td rowspan="3">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp80.keyVersionNumber"
          (input)="handleFormEvents()"
        />
      </td>
      <td style="text-align: center">
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let type of ['80 (DES)', '88 (AES)']; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp80.klc.keyType"
                  [ngClass]="'mx-2'"
                  [inputId]="'profileValues.otaKeys.scp80.klc.keyType#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [(ngModel)]="profileValues.otaKeys.scp80.klc.keyType"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp80.klc.keyType#' + (i + 1)"
                >
                  {{ type }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let size of +profileValues.otaKeys.scp80.klc.keyType !== 1 ? [16, 24, 32] : [16, 24]; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp80.klc.keyDataSize"
                  [ngClass]="'mx-1'"
                  [inputId]="'profileValues.otaKeys.scp80.klc.keyDataSize#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [ngModel]="getKeyDataSizeDisplay('scp80', 'klc')"
                  (ngModelChange)="setKeyDataSize('scp80', 'klc', $event)"
                  [disabled]="profileValues.otaKeys.scp80.klc.isDerived"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp80.klc.keyDataSize#' + i + 1"
                >
                  {{ size }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <p-radioButton
                      (onClick)="handleFormEvents()"
                      name="scp80klcKeyDataValueGeneration"
                      inputId="scp80klcKeyDataValueGeneration#1"
                      value="1"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'klc')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'klc', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80klcKeyDataValueGeneration#1" i18n>eDGAR Generated</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p-radioButton
                      name="scp80klcKeyDataValueGeneration"
                      inputId="scp80klcKeyDataValueGeneration#2"
                      value="2"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'klc')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'klc', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80klcKeyDataValueGeneration#2" i18n>User Defined</label>
                  </td>
                </tr>
                <tr *ngIf="this.isDerivationConfigActive">
                  <td>
                    <p-radioButton
                      name="scp80klcKeyDataValueGeneration"
                      inputId="scp80klcKeyDataValueGeneration#3"
                      value="3"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'klc')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'klc', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80klcKeyDataValueGeneration#3" i18n>Derived</label>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr *ngIf="+profileValues.otaKeys.scp80.klc.keyDataValueGeneration === 2 && profileValues.otaKeys.scp80.klc.isDerived === false">
            <td (mouseover)="showTip(C.TIP_EWIZ_KEY_DATA_VALUE)" (mouseout)="clearDynamicToast()">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="
                  +profileValues.otaKeys.scp80.klc.keyDataSize === 1 ? 32 : +profileValues.otaKeys.scp80.klc.keyDataSize === 2 ? 48 : 64
                "
                [(ngModel)]="profileValues.otaKeys.scp80.klc.keyDataValue"
                (input)="handleKeyDataValue()"
              />
            </td>
          </tr>
          <tr
            *ngIf="
              this.isDerivationConfigActive &&
              +profileValues.otaKeys.scp80.klc.keyDataValueGeneration === 2 &&
              profileValues.otaKeys.scp80.klc.isDerived === true
            "
          >
            <td>
              <p-select
                appendTo="body"
                class="maximize-inputs console-text"
                [placeholder]="derivedKeyPlaceholder('scp80', 'klc')"
                [options]="scp80KeyOptions()"
                (onChange)="enrichKeySelection($event.value, 'scp80', 'klc')"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td style="text-align: center">KID</td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp80.kid.keyIdentifier"
          (input)="handleFormEvents()"
        />
      </td>
      <td style="text-align: center">
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let type of ['80 (DES)', '88 (AES)']; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp80.kid.keyType"
                  [ngClass]="'mx-2'"
                  [inputId]="'profileValues.otaKeys.scp80.kid.keyType#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [(ngModel)]="profileValues.otaKeys.scp80.kid.keyType"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp80.kid.keyType#' + (i + 1)"
                >
                  {{ type }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let size of +profileValues.otaKeys.scp80.kid.keyType !== 1 ? [16, 24, 32] : [16, 24]; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp80.kid.keyDataSize"
                  [ngClass]="'mx-1'"
                  [inputId]="'profileValues.otaKeys.scp80.kid.keyDataSize#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [ngModel]="getKeyDataSizeDisplay('scp80', 'kid')"
                  (ngModelChange)="setKeyDataSize('scp80', 'kid', $event)"
                  [disabled]="profileValues.otaKeys.scp80.kid.isDerived"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp80.kid.keyDataSize#' + (i + 1)"
                >
                  {{ size }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <p-radioButton
                      (onClick)="handleFormEvents()"
                      name="scp80kidKeyDataValueGeneration"
                      inputId="scp80kidKeyDataValueGeneration#1"
                      value="1"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'kid')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'kid', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80kidKeyDataValueGeneration#1" i18n>eDGAR Generated</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p-radioButton
                      name="scp80kidKeyDataValueGeneration"
                      inputId="scp80kidKeyDataValueGeneration#2"
                      value="2"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'kid')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'kid', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80kidKeyDataValueGeneration#2" i18n>User Defined</label>
                  </td>
                </tr>
                <tr *ngIf="this.isDerivationConfigActive">
                  <td>
                    <p-radioButton
                      name="scp80kidKeyDataValueGeneration"
                      inputId="scp80kidKeyDataValueGeneration#3"
                      value="3"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'kid')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'kid', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80kidKeyDataValueGeneration#3" i18n>Derived</label>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr *ngIf="+profileValues.otaKeys.scp80.kid.keyDataValueGeneration === 2 && profileValues.otaKeys.scp80.kid.isDerived === false">
            <td (mouseover)="showTip(C.TIP_EWIZ_KEY_DATA_VALUE)" (mouseout)="clearDynamicToast()">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="
                  +profileValues.otaKeys.scp80.kid.keyDataSize === 1 ? 32 : +profileValues.otaKeys.scp80.kid.keyDataSize === 2 ? 48 : 64
                "
                [(ngModel)]="profileValues.otaKeys.scp80.kid.keyDataValue"
                (input)="handleKeyDataValue()"
              />
            </td>
          </tr>
          <tr
            *ngIf="
              this.isDerivationConfigActive &&
              +profileValues.otaKeys.scp80.kid.keyDataValueGeneration === 2 &&
              profileValues.otaKeys.scp80.kid.isDerived === true
            "
          >
            <td>
              <p-select
                appendTo="body"
                class="maximize-inputs console-text"
                [placeholder]="derivedKeyPlaceholder('scp80', 'kid')"
                [options]="scp80KeyOptions()"
                (onChange)="enrichKeySelection($event.value, 'scp80', 'kid')"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr>
      <td style="text-align: center">DEK</td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp80.dek.keyIdentifier"
          (input)="handleFormEvents()"
        />
      </td>
      <td style="text-align: center">
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let type of ['80 (DES)', '88 (AES)']; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp80.dek.keyType"
                  [ngClass]="'mx-2'"
                  [inputId]="'profileValues.otaKeys.scp80.dek.keyType#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [(ngModel)]="profileValues.otaKeys.scp80.dek.keyType"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp80.dek.keyType#' + (i + 1)"
                >
                  {{ type }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let size of +profileValues.otaKeys.scp80.dek.keyType !== 1 ? [16, 24, 32] : [16, 24]; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp80.dek.keyDataSize"
                  [ngClass]="'mx-1'"
                  [inputId]="'profileValues.otaKeys.scp80.dek.keyDataSize#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [ngModel]="getKeyDataSizeDisplay('scp80', 'dek')"
                  (ngModelChange)="setKeyDataSize('scp80', 'dek', $event)"
                  [disabled]="profileValues.otaKeys.scp80.dek.isDerived"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp80.dek.keyDataSize#' + (i + 1)"
                >
                  {{ size }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <p-radioButton
                      (onClick)="handleFormEvents()"
                      name="scp80dekKeyDataValueGeneration"
                      inputId="scp80dekKeyDataValueGeneration#1"
                      value="1"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'dek')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'dek', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80dekKeyDataValueGeneration#1" i18n>eDGAR Generated</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p-radioButton
                      name="scp80dekKeyDataValueGeneration"
                      inputId="scp80dekKeyDataValueGeneration#2"
                      value="2"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'dek')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'dek', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80dekKeyDataValueGeneration#2" i18n>User Defined</label>
                  </td>
                </tr>
                <tr *ngIf="this.isDerivationConfigActive">
                  <td>
                    <p-radioButton
                      name="scp80dekKeyDataValueGeneration"
                      inputId="scp80dekKeyDataValueGeneration#3"
                      value="3"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp80', 'dek')"
                      (ngModelChange)="setKeyDataValueGeneration('scp80', 'dek', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp80dekKeyDataValueGeneration#3" i18n>Derived</label>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr *ngIf="+profileValues.otaKeys.scp80.dek.keyDataValueGeneration === 2 && profileValues.otaKeys.scp80.dek.isDerived === false">
            <td (mouseover)="showTip(C.TIP_EWIZ_KEY_DATA_VALUE)" (mouseout)="clearDynamicToast()">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="
                  +profileValues.otaKeys.scp80.dek.keyDataSize === 1 ? 32 : +profileValues.otaKeys.scp80.dek.keyDataSize === 2 ? 48 : 64
                "
                [(ngModel)]="profileValues.otaKeys.scp80.dek.keyDataValue"
                (input)="handleKeyDataValue()"
              />
            </td>
          </tr>
          <tr
            *ngIf="
              this.isDerivationConfigActive &&
              +profileValues.otaKeys.scp80.dek.keyDataValueGeneration === 2 &&
              profileValues.otaKeys.scp80.dek.isDerived === true
            "
          >
            <td>
              <p-select
                appendTo="body"
                class="maximize-inputs console-text"
                [placeholder]="derivedKeyPlaceholder('scp80', 'dek')"
                [options]="scp80KeyOptions()"
                (onChange)="enrichKeySelection($event.value, 'scp80', 'dek')"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr style="background: var(--rs-gray-100)" *ngIf="+profileValues.adminAgent.configureAdminAgent === 1">
      <td rowspan="2" style="text-align: center">
        <strong>SCP81</strong>
        <div>(HTTPs)</div>
      </td>
      <td style="text-align: center">PSK</td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp81.psk.keyIdentifier"
          (input)="handleFormEvents()"
        />
      </td>
      <td rowspan="2">
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp81.keyVersionNumber"
          (input)="handleFormEvents()"
        />
      </td>
      <td style="text-align: center">
        <table cellspacing="0" cellpadding="0" class="m-auto">
          <tr>
            <td class="align-content-start ml-1">
              <p-radioButton
                (onClick)="handleFormEvents()"
                name="profileValues.otaKeys.scp81.psk.keyType"
                inputId="profileValues.otaKeys.scp81.psk.keyType#3"
                value="3"
                [ngClass]="'mx-2'"
                [(ngModel)]="profileValues.otaKeys.scp81.psk.keyType"
              ></p-radioButton>
            </td>
            <td class="text-left">
              <label class="label-clickable" for="profileValues.otaKeys.scp81.psk.keyType#3" i18n>85 (PSK for TLS)</label>
            </td>
          </tr>
        </table>
      </td>
      <td>
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let size of [16, 24, 32]; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp81.psk.keyDataSize"
                  [ngClass]="'mx-1'"
                  [inputId]="'profileValues.otaKeys.scp81.psk.keyDataSize#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [(ngModel)]="profileValues.otaKeys.scp81.psk.keyDataSize"
                  [disabled]="profileValues.otaKeys.scp81.psk.isDerived"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp81.psk.keyDataSize#' + (i + 1)"
                >
                  {{ size }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <p-radioButton
                      (onClick)="handleFormEvents()"
                      name="scp81pskKeyDataValueGeneration"
                      inputId="scp81pskKeyDataValueGeneration#1"
                      value="1"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp81', 'psk')"
                      (ngModelChange)="setKeyDataValueGeneration('scp81', 'psk', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp81pskKeyDataValueGeneration#1" i18n>eDGAR Generated</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p-radioButton
                      name="scp81pskKeyDataValueGeneration"
                      inputId="scp81pskKeyDataValueGeneration#2"
                      value="2"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp81', 'psk')"
                      (ngModelChange)="setKeyDataValueGeneration('scp81', 'psk', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp81pskKeyDataValueGeneration#2" i18n>User Defined</label>
                  </td>
                </tr>
                <tr *ngIf="this.isDerivationConfigActive">
                  <td>
                    <p-radioButton
                      name="scp81pskKeyDataValueGeneration"
                      inputId="scp81pskKeyDataValueGeneration#3"
                      value="3"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp81', 'psk')"
                      (ngModelChange)="setKeyDataValueGeneration('scp81', 'psk', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp81pskKeyDataValueGeneration#3" i18n>Derived</label>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr *ngIf="+profileValues.otaKeys.scp81.psk.keyDataValueGeneration === 2 && profileValues.otaKeys.scp81.psk.isDerived === false">
            <td (mouseover)="showTip(C.TIP_EWIZ_KEY_DATA_VALUE)" (mouseout)="clearDynamicToast()">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="
                  +profileValues.otaKeys.scp81.psk.keyDataSize === 1 ? 32 : +profileValues.otaKeys.scp81.psk.keyDataSize === 2 ? 48 : 64
                "
                [(ngModel)]="profileValues.otaKeys.scp81.psk.keyDataValue"
                (input)="handleKeyDataValue()"
              />
            </td>
          </tr>
          <tr
            *ngIf="
              this.isDerivationConfigActive &&
              +profileValues.otaKeys.scp81.psk.keyDataValueGeneration === 2 &&
              profileValues.otaKeys.scp81.psk.isDerived === true
            "
          >
            <td>
              <p-select
                appendTo="body"
                class="maximize-inputs console-text"
                [placeholder]="derivedKeyPlaceholder('scp81', 'psk')"
                [options]="scp81KeyOptions()"
                (onChange)="enrichKeySelection($event.value, 'scp81', 'psk')"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
    <tr style="background: var(--rs-gray-100)" *ngIf="+profileValues.adminAgent.configureAdminAgent === 1">
      <td style="text-align: center">DEK</td>
      <td>
        <input
          pInputText
          rsHexOnlyInput
          class="maximize-inputs console-text text-center"
          [maxlength]="2"
          [(ngModel)]="profileValues.otaKeys.scp81.dek.keyIdentifier"
          (input)="handleFormEvents()"
        />
      </td>
      <td style="text-align: center">
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let type of ['80 (DES)', '88 (AES)']; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp81.dek.keyType"
                  [ngClass]="'mx-2'"
                  [inputId]="'profileValues.otaKeys.scp81.dek.keyType#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [(ngModel)]="profileValues.otaKeys.scp81.dek.keyType"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp81.dek.keyType#' + (i + 1)"
                >
                  {{ type }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table cellspacing="0" cellpadding="0" style="margin: auto">
          <div class="my-3" *ngFor="let size of +profileValues.otaKeys.scp81.dek.keyType !== 1 ? [16, 24, 32] : [16, 24]; let i = index">
            <tr>
              <td>
                <p-radioButton
                  (onClick)="handleFormEvents()"
                  name="profileValues.otaKeys.scp81.dek.keyDataSize"
                  [ngClass]="'mx-1'"
                  [inputId]="'profileValues.otaKeys.scp81.dek.keyDataSize#' + (i + 1)"
                  [value]="`${i + 1}`"
                  [(ngModel)]="profileValues.otaKeys.scp81.dek.keyDataSize"
                  [disabled]="profileValues.otaKeys.scp81.dek.isDerived"
                ></p-radioButton>
              </td>
              <td>
                <label
                  class="mr-3 label-clickable"
                  style="white-space: nowrap !important"
                  [for]="'profileValues.otaKeys.scp81.dek.keyDataSize#' + (i + 1)"
                >
                  {{ size }}
                </label>
              </td>
            </tr>
          </div>
        </table>
      </td>
      <td>
        <table width="100%" cellspacing="0" cellpadding="0">
          <tr>
            <td>
              <table>
                <tr>
                  <td>
                    <p-radioButton
                      (onClick)="handleFormEvents()"
                      name="scp81dekKeyDataValueGeneration"
                      inputId="scp81dekKeyDataValueGeneration#1"
                      value="1"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp81', 'dek')"
                      (ngModelChange)="setKeyDataValueGeneration('scp81', 'dek', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp81dekKeyDataValueGeneration#1" i18n>eDGAR Generated</label>
                  </td>
                </tr>
                <tr>
                  <td>
                    <p-radioButton
                      name="scp81dekKeyDataValueGeneration"
                      inputId="scp81dekKeyDataValueGeneration#2"
                      value="2"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp81', 'dek')"
                      (ngModelChange)="setKeyDataValueGeneration('scp81', 'dek', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp81dekKeyDataValueGeneration#2" i18n>User Defined</label>
                  </td>
                </tr>
                <tr *ngIf="this.isDerivationConfigActive">
                  <td>
                    <p-radioButton
                      name="scp81dekKeyDataValueGeneration"
                      inputId="scp81dekKeyDataValueGeneration#3"
                      value="3"
                      [ngModel]="getKeyDataValueGenerationDisplay('scp81', 'dek')"
                      (ngModelChange)="setKeyDataValueGeneration('scp81', 'dek', $event)"
                    ></p-radioButton>
                  </td>
                  <td>
                    <label class="ml-2 mr-6 label-clickable" for="scp81dekKeyDataValueGeneration#3" i18n>Derived</label>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          <tr *ngIf="+profileValues.otaKeys.scp81.dek.keyDataValueGeneration === 2 && profileValues.otaKeys.scp81.dek.isDerived === false">
            <td (mouseover)="showTip(C.TIP_EWIZ_KEY_DATA_VALUE)" (mouseout)="clearDynamicToast()">
              <input
                pInputText
                rsHexOnlyInput
                class="maximize-inputs console-text"
                [maxlength]="
                  +profileValues.otaKeys.scp81.dek.keyDataSize === 1 ? 32 : +profileValues.otaKeys.scp81.dek.keyDataSize === 2 ? 48 : 64
                "
                [(ngModel)]="profileValues.otaKeys.scp81.dek.keyDataValue"
                (input)="handleKeyDataValue()"
              />
            </td>
          </tr>
          <tr
            *ngIf="
              this.isDerivationConfigActive &&
              +profileValues.otaKeys.scp81.dek.keyDataValueGeneration === 2 &&
              profileValues.otaKeys.scp81.dek.isDerived === true
            "
          >
            <td>
              <p-select
                appendTo="body"
                class="maximize-inputs console-text"
                [placeholder]="derivedKeyPlaceholder('scp81', 'dek')"
                [options]="scp81KeyOptions()"
                (onChange)="enrichKeySelection($event.value, 'scp81', 'dek')"
              />
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
